import React, { useState } from "react";
import {
  Container,
  Input,
  InputGroup,
  InputGroupText,
  ListGroup,
  ListGroupItem,
} from "reactstrap";
import Link from "next/link";
import { FaSearch } from "react-icons/fa";

import { getArticleEntries } from "../utils/help-page-utils";
import classes from "@/styles/generic/help.module.css";
import searchClasses from "@/styles/help/search-bar.module.css";
import { helpArticle } from "@/utils/content";
import {
  articleMapping,
  categoryMapping,
  collections,
} from "./help-articles-data";
import { MdChevronRight } from "react-icons/md";
import { useIsMobile } from "@/hooks/useIsMobile";

type Props = {
  basePath: string;
};

const allArticlesEntries = getArticleEntries();

const SearchBar = ({ basePath }: Props) => {
  const content = helpArticle.en;
  const isMobile = useIsMobile();
  const [search, setSearch] = useState("");
  const searchResults = !search
    ? allArticlesEntries
    : allArticlesEntries.filter((a) =>
        a.artTitle.toLowerCase().includes(search.toLowerCase())
      );

  const handleKeyDown = (
    e: React.KeyboardEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    if (e.key === "Escape") {
      setSearch("");
    }
  };
  return (
    <div className="my-5">
      <Container>
        <InputGroup className={classes.inputGroup}>
          <Input
            className={classes.input}
            type="search"
            onKeyDown={handleKeyDown}
            placeholder={content.inputPlaceholder}
            onChange={(e) => setSearch(e.target.value)}
            value={search}
          />
          <InputGroupText>
            <FaSearch />
          </InputGroupText>
        </InputGroup>

        {search && (
          <div
            className={`mt-2 shadow rounded ${searchClasses.searchContainer}`}
          >
            <ListGroup className="rounded-0 ">
              {searchResults.length > 0 ? (
                <>
                  {searchResults.map(
                    ({ colIndex, catKey, artKey, artTitle }, i) => {
                      const collection = collections[colIndex];
                      const category = catKey ? categoryMapping[catKey] : null;
                      const article = articleMapping[artKey];
                      const partialLink = category
                        ? [collection.link, category.link, article.link].join(
                            "/"
                          )
                        : [collection.link, article.link].join("/");

                      return (
                        <ListGroupItem
                          className={searchClasses.searchListItem}
                          key={partialLink + "-" + i}
                        >
                          <Link
                            href={basePath + "/" + partialLink}
                            className={searchClasses.searchLink}
                            onClick={() => setSearch("")}
                          >
                            <span className="collection">
                              {isMobile ? "..." : collection.title}
                            </span>
                            <MdChevronRight size={18} />
                            {category && (
                              <>
                                <span className="category">
                                  {category.title}
                                </span>
                                <MdChevronRight size={18} />
                              </>
                            )}
                            <span className={searchClasses.searchTitle}>
                              {artTitle}&nbsp;
                            </span>
                          </Link>
                        </ListGroupItem>
                      );
                    }
                  )}
                </>
              ) : (
                <ListGroupItem>
                  <span>Sorry there are no result for that search</span>
                </ListGroupItem>
              )}
            </ListGroup>
          </div>
        )}
      </Container>
    </div>
  );
};

export default SearchBar;
